import { Dispatch, SetStateAction, useState } from 'react';
import { UploadedFile } from 'web-library/models/UploadedFile';

export interface ErrorObject {
  id: FormIds;
  text: string;
}

export enum FormIds {
  UPLOAD_DOCUMENTS_CONTAINER = 'upload-document-container',
}

interface UploadDocumentProps {
  files: UploadedFile[];
  setFiles: Dispatch<SetStateAction<UploadedFile[]>>;
}

const useUploadDocument = ({ files, setFiles }: UploadDocumentProps) => {
  const [disableDelete, setDisableDelete] = useState<boolean>(false);

  const getFilenames = () => {
    setDisableDelete(true);
    const newFiles: UploadedFile[] = [];

    files.forEach((file) => {
      const pendingFile = file;

      if (!pendingFile.uploaded) {
        pendingFile.pending = true;
      }
      newFiles.push(pendingFile);
    });

    setFiles(newFiles);

    return newFiles.map((uploadFile) => uploadFile.file.name);
  };

  return {
    getFilenames,
    disableDelete,
  };
};

export default useUploadDocument;
